export default __webpack_public_path__ + "static/media/mc-image2.572ad01b.png";